import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  login: {
    isRequired: boolean;
    isLoading: boolean;
    isAuthorized: boolean;
    error: string | null;
  };
  user: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  login: {
    isRequired: true,
    isLoading: false,
    isAuthorized: false,
    error: null,
  },
  user: {
    isLoading: false,
    data: null,
    error: null,
  },
};

export const { actions: authActions, reducer: authReducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginRequired: (state, { payload }) => {
      state.login = {
        ...state.login,
        isRequired: payload,
      };
    },
    setLoginRequest: (state) => {
      state.login = {
        isRequired: false,
        isLoading: true,
        isAuthorized: false,
        error: null,
      };
    },
    setLoginSuccess: (state) => {
      state.login = {
        isRequired: false,
        isLoading: false,
        isAuthorized: true,
        error: null,
      };
    },
    setLoginFailure: (state, { payload }) => {
      state.login = {
        isRequired: false,
        isLoading: false,
        isAuthorized: false,
        error: payload.message,
      };
    },
    setLogout: (state) => {
      state.login = {
        isRequired: false,
        isLoading: false,
        isAuthorized: false,
        error: null,
      };
    },
    setUserRequest: (state) => {
      state.user = {
        ...state.user,
        isLoading: true,
        error: null,
      };
    },
    setUserSuccess: (state, { payload }) => {
      state.user = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setUserFailure: (state, { payload }) => {
      state.user = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setUserDefault: (state) => {
      state.user = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
  },
});
